import { Component, Injectable, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { DecimalPipe, CommonModule, DatePipe } from '@angular/common';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



@Component({
  selector: 'app-payroll-sheet',
  imports: [CommonModule, DatePipe],
  templateUrl: './payroll-sheet.component.html',
  styleUrl: './payroll-sheet.component.css'
})
@Injectable({
  providedIn: 'root',
})
export class PayrollSheetComponent implements OnInit {
  salary_detail: any;
  user: any;
  printingContent: any;
  last_rout: any;
  // In your component.ts
monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

 constructor(
    private router: Router,
     private route: ActivatedRoute,

    public payrollService: PayrollService
  ) {

  }
  ngOnInit(): void {
     const state = history.state;
    this.salary_detail = state.data;
    console.log(this.salary_detail);
    this.last_rout = state.from

    if(this.salary_detail){
      this.user=state.user;
    }else{
      this.user = JSON.parse(localStorage.getItem('user') || '');
          this.route.queryParams.subscribe(params => {
        if (params['data']) {
          const data = JSON.parse(params['data']);
          this.salary_detail = data;
        }
      });

    }
    
  }


  downloadPDF() {
    const DATA = document.getElementById('salary-slip');
    if (!DATA) return;

    html2canvas(DATA, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save('salary-slip.pdf');
    });
  }


   titleCase(value: string | undefined | null): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  goBack() {
    if(this.last_rout == '/past-payroll'){
       this.router.navigate(['past-payroll'], {
        state: {
          user_id: this.salary_detail.user_id,
          from: 'payroll-sheet'
        }
      });
    }else{
      this.router.navigate(['/payroll-main']);
    }
  }
}
